import React from "react";
import ModalBoxCore from "../../../core-components/modal-box/ModalBoxCore";
import ModalBody from "../../../core-components/modal-box/modal-body/ModalBody";
import panelImage from "../../../../assets/images/b2b/Panel-image.png";
import AccessAndReuseSvg from "../../../../assets/svg-fc/b2b/PhotoLibrarySvgs/AccessAndReuseSvg";
import UploadPhotoSvg from "../../../../assets/svg-fc/b2b/PhotoLibrarySvgs/UploadPhotoSvg";
import OrganizeImagesSvg from "../../../../assets/svg-fc/b2b/PhotoLibrarySvgs/OrganizeImagesSvg";
import CoreButtons from "../../../core-components/button/CoreButtons";
import DisclaimerImageSvg from "../../../../assets/svg-fc/b2b/PhotoLibrarySvgs/DisclaimerImageSvg";
import "./addQuoteImagesModal.scss";

interface IAddQuoteImagesModalProps {
	open: boolean;
	setShowPhotoLibrary: (show: boolean) => void;
	onClose: () => void;
}

const AddQuoteImagesModal: React.FC<IAddQuoteImagesModalProps> = ({ open, onClose, setShowPhotoLibrary }) => {

	return (
		<ModalBoxCore className="addQuoteImagesModal" open={open} onClose={onClose}>
			<ModalBody>
					<div className="encouragement-modal">
						<div className="encouragement-modal__content">
							<div className="encouragement-modal__left">
								<h2>Please Add Images to Your Quote</h2>
								<p className="encouragement-modal__intro">
									Images are <strong>required</strong> to make your quote visually attractive and
									significantly increase customer engagement.
								</p>

								<div className="encouragement-modal__key-message">
									<div className="key-message-icon">
										<DisclaimerImageSvg />
									</div>
									<div className="key-message-text">
										<strong>For illustrative purposes only</strong>
										<p>
											The images don't have to be exact matches. They serve to give customers a visual
											representation of your offerings.
										</p>
									</div>
								</div>

								<div className="encouragement-modal__divider"></div>

								<div className="encouragement-modal__features">
									<p className="features-subtitle">Your photo library is available to help:</p>

									<div className="feature-item">
										<AccessAndReuseSvg />
										<span>Access and reuse previously uploaded images</span>
									</div>

									<div className="feature-item">
										<UploadPhotoSvg />
										<span>Upload new photos to save in your library</span>
									</div>

									<div className="feature-item">
										<OrganizeImagesSvg />
										<span>Organize images into custom categories</span>
									</div>
								</div>

								<div className="encouragement-modal__actions">
									<CoreButtons
										className="add-images-btn"
										buttonText="Add Images to Quote"
										onclick={() => setShowPhotoLibrary(false)}
									/>
								</div>
							</div>

							<div className="encouragement-modal__right">
								<div className="encouragement-image-container">
									<img
										src={panelImage}
										alt="Quote with images example"
										className="encouragement-example-image"
									/>
								</div>
							</div>
						</div>

						<button className="encouragement-modal__close" onClick={() => onClose()} title="Close">
							✕
						</button>
					</div>
			</ModalBody>
		</ModalBoxCore>
	);
};

export default AddQuoteImagesModal;
